export default {
    topics: [
        {
            title: ' comment ',
            href: 'p-Cookie-comment.html',
            attributes: { 'data-id': 'p-Cookie-comment' },
            menu: { hasChildren: false },
            tocID: 'p-Cookie-comment-d66e7598',
            topics: [],
        },
        {
            title: ' domain ',
            href: 'p-Cookie-domain.html',
            attributes: { 'data-id': 'p-Cookie-domain' },
            menu: { hasChildren: false },
            tocID: 'p-Cookie-domain-d66e7606',
            topics: [],
        },
        {
            title: ' maxAge ',
            href: 'p-Cookie-maxAge.html',
            attributes: { 'data-id': 'p-Cookie-maxAge' },
            menu: { hasChildren: false },
            tocID: 'p-Cookie-maxAge-d66e7614',
            topics: [],
        },
        {
            title: ' name ',
            href: 'p-Cookie-name.html',
            attributes: { 'data-id': 'p-Cookie-name' },
            menu: { hasChildren: false },
            tocID: 'p-Cookie-name-d66e7622',
            topics: [],
        },
        {
            title: ' path ',
            href: 'p-Cookie-path.html',
            attributes: { 'data-id': 'p-Cookie-path' },
            menu: { hasChildren: false },
            tocID: 'p-Cookie-path-d66e7630',
            topics: [],
        },
        {
            title: ' secure ',
            href: 'p-Cookie-secure.html',
            attributes: { 'data-id': 'p-Cookie-secure' },
            menu: { hasChildren: false },
            tocID: 'p-Cookie-secure-d66e7638',
            topics: [],
        },
        {
            title: ' value ',
            href: 'p-Cookie-value.html',
            attributes: { 'data-id': 'p-Cookie-value' },
            menu: { hasChildren: false },
            tocID: 'p-Cookie-value-d66e7646',
            topics: [],
        },
        {
            title: ' version ',
            href: 'p-Cookie-version.html',
            attributes: { 'data-id': 'p-Cookie-version' },
            menu: { hasChildren: false },
            tocID: 'p-Cookie-version-d66e7654',
            topics: [],
        },
    ],
};

